import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import MasterNavbar from '../components/layout/MasterNavbar';
import {
  CUSTOMER_SAVE_ENDPOINT,
  GET_CUSTOMER_DATA_ENDPOINT, DISTRIBUTOR_LIST_ENDPOINT
} from '../utils/api';

function CustomersAdd() {
  const [form, setForm] = useState({
    name: '',
    address: '',
    state: '',
    city: '',
    pincode: '',
    gst_no: '',
    pan_no: '',
    remark: '',
     distributor_id: ''
  });
const [distributors, setDistributors] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();
  const { id, customer_token } = useParams();

  const getUserId = () => {
    const token = localStorage.getItem('token');
    try {
      const user = JSON.parse(atob(token));
      return user?.id || 0;
    } catch {
      return 0;
    }
  };

useEffect(() => {
  const fetchDistributors = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(DISTRIBUTOR_LIST_ENDPOINT, { token });
      if (res.data.success) {
        setDistributors(res.data.distributors || []);
      } else {
        toast.error('Unable to load distributors');
      }
    } catch {
      toast.error('Error loading distributor list');
    }
  };

  fetchDistributors();
}, []);


  useEffect(() => {
    if (id && customer_token) {
      setEditMode(true);
      axios
        .post(GET_CUSTOMER_DATA_ENDPOINT, { id, customer_token })
        .then((res) => {
          if (res.data.success && res.data.customer) {
            setForm({
              name: res.data.customer.name || '',
              address: res.data.customer.address || '',
              state: res.data.customer.state || '',
              city: res.data.customer.city || '',
              pincode: res.data.customer.pincode || '',
              gst_no: res.data.customer.gst_no || '',
              pan_no: res.data.customer.pan_no || '',
              remark: res.data.customer.remark || '',
               distributor_id: res.data.customer.distributor_id || ''
            });
          } else {
            toast.error(res.data.message || 'Failed to load customer');
          }
        })
        .catch(() => toast.error('Error loading customer data'));
    }
  }, [id, customer_token]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const user_id = getUserId();
    if (!user_id) {
      toast.error('Invalid or missing token');
      return;
    }

    const payload = { ...form, user_id };

    if (editMode) {
      payload.id = id;
      payload.customer_token = customer_token;
    }

    try {
      const res = await axios.post(CUSTOMER_SAVE_ENDPOINT, payload);
      if (res.data.success) {
        toast.success(res.data.message || 'Customer saved successfully');
        setTimeout(() => navigate('/customers/show'), 1200);
      } else {
        toast.error(res.data.message || 'Failed to save customer');
      }
    } catch {
      toast.error('Server error while saving customer');
    }
  };

  return (
    <>
      <MasterNavbar />
      <Toaster position="top-center" />
      <div className="container mt-5">
        <div className="card shadow p-4 mx-auto" style={{ maxWidth: '700px' }}>
          <h4 className="mb-4 text-center">
            {editMode ? '✏️ Edit Customer' : '➕ Add New Customer'}
          </h4>


<select
  name="distributor_id"
  className="form-control mb-3"
  value={form.distributor_id}
  onChange={handleChange}
>
  <option value="">-- Select Distributor --</option>
  {distributors.map((d) => (
    <option key={d.id} value={d.id}>{d.id}-{d.name}</option>
  ))}
</select>


          <input type="text" name="name" value={form.name} onChange={handleChange} className="form-control mb-3" placeholder="Customer Name" />
          <textarea name="address" value={form.address} onChange={handleChange} className="form-control mb-3" placeholder="Address" />
          <input type="text" name="state" value={form.state} onChange={handleChange} className="form-control mb-3" placeholder="State" />
          <input type="text" name="city" value={form.city} onChange={handleChange} className="form-control mb-3" placeholder="City" />
          <input type="text" name="pincode" value={form.pincode} onChange={handleChange} className="form-control mb-3" placeholder="Pincode" />
          <input type="text" name="gst_no" value={form.gst_no} onChange={handleChange} className="form-control mb-3" placeholder="GST No" />
          <input type="text" name="pan_no" value={form.pan_no} onChange={handleChange} className="form-control mb-3" placeholder="PAN No" />
          <textarea name="remark" value={form.remark} onChange={handleChange} className="form-control mb-4" placeholder="Remark" />

          <button className="btn btn-primary w-100" onClick={handleSubmit}>
            {editMode ? 'Update Customer' : 'Save Customer'}
          </button>
        </div>
      </div>
    </>
  );
}

export default CustomersAdd;
